/* eslint-disable react-hooks/exhaustive-deps */
import { InfoCircleTwoTone, PlusOutlined } from "@ant-design/icons";
import { Alert, Button, Col, Empty, Row, Table, Tabs, Typography } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useFieldArray, useFormContext, useFormState } from "react-hook-form";
import PilotInformationForm from "./PilotInformationForm";
import { emptyPilotObject } from "./emptyPilotObject";
import { pilotInformationColumns } from "./pilotInformationColumns";

const PilotInformation = () => {
  const { control, trigger, getValues } = useFormContext();
  const { errors, isSubmitting } = useFormState({
    control: control,
    name: "pilots",
  });

  const { fields, append, remove, update } = useFieldArray({
    control: control,
    name: "pilots",
  });
  const [currentActiveTab, setCurrentActiveTab] = useState(0);

  const columns = useCallback(
    pilotInformationColumns({
      setCurrentActiveTab,
      fields,
      remove,
      update,
      currentActiveTab,
      errors,
    }),
    [setCurrentActiveTab, fields, remove, update, currentActiveTab, errors],
  );
  const [showErrors, setShowErrors] = useState({});
  const updateShowErrorsList = () => {
    var newMap = { ...showErrors };
    fields.forEach((e) => {
      newMap[e.id] = true;
    });
    setShowErrors(newMap);
  };
  useEffect(() => {
    if (isSubmitting) {
      updateShowErrorsList();
    }
  }, [isSubmitting]);

  useEffect(() => {
    trigger("pilots");
  }, []);

  const items = fields.map((item, index) => {
    return {
      label:
        (item.pilot_first_name !== "" && item.pilot_first_name != null) ||
        (item.pilot_last_name !== "" && item.pilot_last_name != null)
          ? (
              (item.pilot_first_name ?? "") +
              " " +
              (item.pilot_last_name ?? "")
            ).trim()
          : `Pilot ${index + 1}`,
      children: (
        <PilotInformationForm
          showErrors={showErrors?.[item.id]}
          item={item}
          baseName={`pilots[${index}].`}
          index={index}
        />
      ),
      key: index,
    };
  });

  const onAddPilot = () => {
    updateShowErrorsList();
    append(emptyPilotObject);
    trigger("pilots");
    setCurrentActiveTab(fields.length);
  };

  const prefilled = getValues()?.prefilled ?? false;

  return (
    <div>
      {prefilled && (
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: "24px" }}
          message="Pilot hours have been prefilled based on last year’s records. Please carefully review and update the hours and rating information for each pilot to ensure accuracy."
        />
      )}
      <Row style={{ marginBottom: "24px" }}>
        <Col span={24}>
          <Table
            title={() => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  fontWeight: 500,
                  color: "black",
                  fontSize: 15,
                }}
              >
                <InfoCircleTwoTone style={{ fontSize: 18 }} />
                <span>Please list all pilots below</span>
              </div>
            )}
            scroll={{ x: 630 }}
            size="small"
            columns={columns}
            dataSource={fields}
            pagination={false}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_DEFAULT}
                  description={
                    <div>
                      <div style={{ fontWeight: 500, color: "#999" }}>
                        No pilots added yet
                      </div>

                      <div style={{ marginTop: 8, color: "#333" }}>
                        Most aircraft have at least one pilot.{" "}
                        <Typography.Link onClick={onAddPilot}>
                          Add a pilot
                        </Typography.Link>{" "}
                        to continue.
                        <br />
                        <span style={{ fontSize: 13 }}>
                          If the aircraft is in storage or under repair, you can
                          leave this empty.
                        </span>
                      </div>
                    </div>
                  }
                />
              ),
            }}
            // virtual
            bordered
            // sticky
            rowClassName={(_, index) =>
              index === currentActiveTab ? "highlight-pilot-table-row" : null
            }
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: "24px" }}>
        <Col span={24}>
          <Button
            type="default"
            size="medium"
            disabled={fields.length > 4}
            onClick={onAddPilot}
          >
            <PlusOutlined /> Add a pilot
          </Button>
        </Col>
      </Row>

      {/* I do not wish to add any pilots */}
      <Row>
        <Col span={24}>
          <Tabs
            activeKey={currentActiveTab}
            hideAdd
            type="card"
            onEdit={null}
            items={items}
            onChange={(e) => {
              setCurrentActiveTab(e);
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default PilotInformation;
